import React from 'react';

export default (Component, book) => (props) => (
    <Component match={{ params: { bookId: book } }} {...props} />
);
